import { useEffect, useState } from 'react';

import { Typography } from '@mui/material';

const DateTimeWrapper = ({ date, format, style = {} }) => {
    const [localDate, setLocalDate] = useState(date);

    useEffect(() => {
        let newLocalDate = format(date);
        setLocalDate(newLocalDate);
    }, [date]);

    return (
        <Typography style={style} component="span">
            {localDate}
        </Typography>
    );
};

export default DateTimeWrapper;
